import {
  LOGIN_REQUESTING,
  CHECK_AUTHENTICATED,
  SET_AUTHENTICATED,
  UNSET_AUTHENTICATED,
  LOGOUT,
  LOGOUT_NO_REDIRECT,
} from './constants'

export const checkAuthenticated = function setAuthenticated() {
  return {
    type: CHECK_AUTHENTICATED,
  }
}

export const setAuthenticated = function setAuthenticated() {
  return {
    type: SET_AUTHENTICATED,
  }
}

export const unsetAuthenticated = function unsetAuthenticated() {
  return {
    type: UNSET_AUTHENTICATED,
  }
}

// In order to perform an action of type LOGIN_REQUESTING
// we need an email and password
export const login = function login(payload) {
  return {
    type: LOGIN_REQUESTING,
    payload,
  }
}

export const logout = function logout() {
  return {
    type: LOGOUT,
  }
}

export const logout_no_redirect = function logout() {
  return {
    type: LOGOUT_NO_REDIRECT,
  }
}
